module.exports = __webpack_public_path__ + "static/media/OMS.11a0ebd9.JPG";